<template>
  <img :src=image>
</template>

<script>
  export default {
    name: "bedding",
    props: {
      title: String,
      thumbnail: String,
      variant: String,
      color: String,
      imgURL: String,
    },
    computed: {
      image: function () {
        return this.imgURL + "Bettung/" + this.variant + ['/footbed', this.variant, this.color].join('_') + ".png"
      }
    },
    created() {
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bedding.vue